import { eraseCookie, getCookie, setCookie } from './CookieService'
const cookieCredentials = '__alerta_jwt__'
const cookieToken = 'access_token'
export const client = (endpoint: string, { body, ...customConfig } : any = {}) => {
  const token = getCookie(cookieToken)
  const headers = { 'content-type': 'application/json', Authorization: '' }
  if (token) {
    headers.Authorization = `JWT ${token}`
  }
  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers
    }
  }
  if (body) {
    config.body = JSON.stringify(body)
  }
  return window
    .fetch(`${endpoint}`, config)
    .then(async response => {
      if (response.status === 401) {
        logout()
        return
      }
      const data = await response.json()
      if (response.ok) {
        return data
      } else {
        return Promise.reject(data)
      }
    })
}
function logout () {
  eraseCookie(cookieCredentials)
  eraseCookie(cookieToken)
}
